module.exports = __webpack_public_path__ + "fonts/Inter-600-greek39.8c7f6ae.woff2";